<div class="outer-container">
   <div class="button-grid">
      <div class="button-container">
         <button
            pButton
            label="Account Mappings"
            (click)="setSelectedButton('created')"
            [ngClass]="{ selected: selectedButton === 'created' }"
            class="custom-btn green-btn"></button>
      </div>

      <div class="button-container">
         <button
            pButton
            label="Terminated Accounts"
            (click)="setSelectedButton('terminated')"
            [ngClass]="{ selected: selectedButton === 'terminated' }"
            class="custom-btn red-btn"></button>
      </div>

      <div class="button-container">
         <button
            pButton
            label="Unknown Accounts"
            (click)="setSelectedButton('unknown')"
            [ngClass]="{ selected: selectedButton === 'unknown' }"
            class="custom-btn blue-btn"></button>
      </div>

      <div class="button-container">
         <button
            pButton
            label="Manage Exclusions"
            (click)="setSelectedButton('exclusions')"
            [ngClass]="{ selected: selectedButton === 'exclusions' }"
            class="custom-btn purple-btn"></button>
      </div>
   </div>

   <div class="panel-frame">
      <div
         *ngIf="selectedButton === 'created'"
         class="title-heading">
         Dayforce/Entra
         <span class="created-heading">Account Mappings</span>
      </div>

      <div
         *ngIf="selectedButton === 'terminated'"
         class="title-heading">
         Recently
         <span class="terminated-heading">Terminated Accounts</span>
      </div>

      <div
         *ngIf="selectedButton === 'unknown'"
         class="title-heading">
         <span class="unknown-heading">Unknown Active Entra Accounts</span>
      </div>

      <div
         *ngIf="selectedButton === 'exclusions'"
         class="title-heading">
         <span class="exclusions-heading">Manage Exclusions</span>
      </div>

      <div *ngIf="selectedButton === 'created'">
         <p-table
            #crttbl
            [value]="additions"
            [paginator]="true"
            [rows]="40"
            [globalFilterFields]="['dayforceEmployeeNumber', 'entraUPN', 'entraDisplayName', 'syncDate']"
            responsiveLayout="scroll"
            [sortField]="'syncDate'"
            [sortOrder]="-1">
            <ng-template pTemplate="caption">
               <div class="search-header">
                  <p-iconfield>
                     <p-inputicon class="pi pi-search"></p-inputicon>
                     <input
                        pInputText
                        type="text"
                        (input)="crttbl.filterGlobal($event.target.value, 'contains')"
                        placeholder="Search..." />
                  </p-iconfield>
               </div>
            </ng-template>

            <ng-template pTemplate="header">
               <tr>
                  <th>Dayforce Employee #</th>
                  <th>Mapped Entra UPN</th>
                  <th>Display Name</th>
                  <th>Sync Date</th>
                  <th></th>
               </tr>
            </ng-template>

            <ng-template
               pTemplate="body"
               let-addition>
               <tr>
                  <td>{{ addition.dayforceEmployeeNumber }}</td>
                  <td>{{ addition.entraUPN }}</td>
                  <td>{{ addition.entraDisplayName }}</td>
                  <td>{{ addition.syncDate | date : "yyyy-MM-dd" }}</td>
                  <td style="padding: 4px; width: 160px">
                     <div class="row-button-grid">
                        <div class="row-button-container">
                           <p-button
                              class="hover-button"
                              label="Edit UPN"
                              variant="outlined"
                              severity="info"
                              size="small"
                              pTooltip="Edit Mapped UPN"
                              showDelay="1000"
                              (click)="editUPN(addition.entraUPN)" />
                        </div>
                        <div class="entra-icon-button-div row-button-container">
                           <button
                              pButton
                              pTooltip="Open Entra Profile"
                              showDelay="1000"
                              class="entra-icon-button hover-button"
                              (click)="openEntraProfile(addition.entraUPN)">
                              <img
                                 src="assets/entra-user-icon.png"
                                 class="button-icon" />
                           </button>
                        </div>
                     </div>

                     <!-- <div class="entra-icon-button-div">
                        <button
                           pButton
                           class="entra-icon-button hover-button"
                           (click)="openEntraProfile(addition.entraUPN)">
                           <img
                              src="assets/entra-user-icon.png"
                              class="button-icon" />
                        </button>
                     </div> -->
                  </td>
               </tr>
            </ng-template>
         </p-table>
      </div>

      <div *ngIf="selectedButton === 'terminated'">
         <p-table
            #termtbl
            [value]="disables"
            [paginator]="true"
            [rows]="40"
            [globalFilterFields]="['employeeNumber', 'entraUPN', 'displayName', 'syncDate']"
            responsiveLayout="scroll"
            [sortField]="'syncDate'"
            [sortOrder]="-1">
            <ng-template pTemplate="caption">
               <div class="search-header">
                  <p-iconfield>
                     <p-inputicon class="pi pi-search"></p-inputicon>
                     <input
                        pInputText
                        type="text"
                        (input)="termtbl.filterGlobal($event.target.value, 'contains')"
                        placeholder="Search..." />
                  </p-iconfield>
               </div>
            </ng-template>

            <ng-template pTemplate="header">
               <tr>
                  <th>Dayforce Employee #</th>
                  <th>Entra UPN</th>
                  <th>Display Name</th>
                  <th>Sync Date</th>
                  <th></th>
               </tr>
            </ng-template>

            <ng-template
               pTemplate="body"
               let-disable>
               <tr>
                  <td>{{ disable.employeeNumber }}</td>
                  <td>{{ disable.entraUPN }}</td>
                  <td>{{ disable.displayName }}</td>
                  <td>{{ disable.syncDate | date : "yyyy-MM-dd" }}</td>
                  <td style="padding: 4px; width: 120px">
                     <div class="row-button-grid">
                        <div class="entra-icon-button-div row-button-container">
                           <button
                              pButton
                              pTooltip="Open Entra Profile"
                              showDelay="1000"
                              class="entra-icon-button hover-button"
                              (click)="openEntraProfile(disable.entraUPN)">
                              <img
                                 src="assets/entra-user-icon.png"
                                 class="button-icon" />
                           </button>
                        </div>
                     </div>
                  </td>
               </tr>
            </ng-template>
         </p-table>
      </div>

      <div *ngIf="selectedButton === 'unknown'">
         <p-table
            #unktbl
            [value]="unknowns"
            [paginator]="true"
            [rows]="40"
            responsiveLayout="scroll"
            [globalFilterFields]="['displayName', 'userPrincipalName', 'selectedExclusion']"
            [sortField]="'createdDateTime'"
            [sortOrder]="-1">
            <ng-template pTemplate="caption">
               <div class="search-header">
                  <p-iconfield>
                     <p-inputicon class="pi pi-search"></p-inputicon>
                     <input
                        pInputText
                        type="text"
                        (input)="unktbl.filterGlobal($event.target.value, 'contains')"
                        placeholder="Search..." />
                  </p-iconfield>
               </div>
            </ng-template>

            <ng-template pTemplate="header">
               <tr>
                  <th
                     class="with-max-width"
                     pSortableColumn="userPrincipalName">
                     User Principal Name
                     <p-sortIcon field="userPrincipalName"></p-sortIcon>
                  </th>
                  <th
                     class="with-max-width"
                     pSortableColumn="displayName">
                     Display Name
                     <p-sortIcon field="displayName"></p-sortIcon>
                  </th>
                  <th pSortableColumn="createdDateTime">
                     Created Date
                     <p-sortIcon field="createdDateTime"></p-sortIcon>
                  </th>
                  <th>Take Action</th>
                  <th></th>
               </tr>
            </ng-template>

            <ng-template
               pTemplate="body"
               let-unknown>
               <tr>
                  <td class="with-max-width">{{ unknown.userPrincipalName }}</td>
                  <td class="with-max-width">{{ unknown.displayName }}</td>
                  <td>{{ unknown.createdDateTime }}</td>
                  <td style="width: 300px">
                     <p-select
                        [options]="actionOptions"
                        placeholder="Select Action"
                        [style]="{ width: '280px' }"
                        [(ngModel)]="unknown.selectedAction"
                        (onChange)="handleUnknownAccountAction($event, unknown)"></p-select>
                  </td>
                  <td style="padding-top: 6px; padding-bottom: 6px">
                     <div class="row-button-grid">
                        <div
                           *ngIf="unknownsToSave?.[unknown.userPrincipalName]"
                           class="row-button-container">
                           <p-button
                              pTooltip="Save Action Dropdown"
                              showDelay="1000"
                              label="Save Row"
                              size="small"
                              variant="outlined"
                              severity="success"
                              (click)="saveUnknownAccountAction(unknown)" />
                        </div>
                        <div class="entra-icon-button-div row-button-container">
                           <button
                              pButton
                              pTooltip="Open Entra Profile"
                              showDelay="1000"
                              class="entra-icon-button hover-button"
                              (click)="openEntraProfile(unknown.userPrincipalName)">
                              <img
                                 src="assets/entra-user-icon.png"
                                 class="button-icon" />
                           </button>
                        </div>
                     </div>
                  </td>
               </tr>
            </ng-template>
         </p-table>
      </div>

      <div *ngIf="selectedButton === 'exclusions'">
         <p-table
            #excltbl
            [value]="exclusions"
            [paginator]="true"
            [rows]="40"
            [globalFilterFields]="['entraDisplayName', 'userPrincipalName', 'selectedExclusion']"
            responsiveLayout="scroll">
            <ng-template pTemplate="caption">
               <div class="search-header">
                  <p-iconfield>
                     <p-inputicon class="pi pi-search"></p-inputicon>
                     <input
                        pInputText
                        type="text"
                        (input)="excltbl.filterGlobal($event.target.value, 'contains')"
                        placeholder="Search..." />
                  </p-iconfield>
               </div>
            </ng-template>

            <ng-template pTemplate="header">
               <tr>
                  <th pSortableColumn="entraDisplayName">
                     Display Name
                     <p-sortIcon field="entraDisplayName"></p-sortIcon>
                  </th>
                  <th pSortableColumn="userPrincipalName">
                     User Principal Name
                     <p-sortIcon field="userPrincipalName"></p-sortIcon>
                  </th>
                  <th pSortableColumn="selectedExclusion">
                     Exclusions
                     <p-sortIcon field="selectedExclusion"></p-sortIcon>
                  </th>
                  <th></th>
               </tr>
            </ng-template>

            <ng-template
               pTemplate="body"
               let-exclusion>
               <tr>
                  <td>{{ exclusion.entraDisplayName }}</td>
                  <td>{{ exclusion.userPrincipalName }}</td>
                  <td>
                     <p-select
                        [options]="exclusionOptions"
                        [(ngModel)]="exclusion.selectedExclusion"
                        placeholder="Select Exclusion"
                        [style]="{ width: '240px' }"
                        (onChange)="handleExclusionChange($event, exclusion)"></p-select>
                  </td>
                  <td style="padding-top: 6px; padding-bottom: 6px">
                     <div class="row-button-grid">
                        <div
                           *ngIf="exclusionsToSave?.[exclusion.userPrincipalName]"
                           class="row-button-container">
                           <p-button
                              pTooltip="Save Exclusion Change"
                              showDelay="1000"
                              label="Save Row"
                              size="small"
                              variant="outlined"
                              severity="success"
                              (click)="saveExclusionChange(exclusion)" />
                        </div>
                        <div class="entra-icon-button-div row-button-container">
                           <button
                              pButton
                              pTooltip="Open Entra Profile"
                              showDelay="1000"
                              class="entra-icon-button hover-button"
                              (click)="openEntraProfile(exclusion.userPrincipalName)">
                              <img
                                 src="assets/entra-user-icon.png"
                                 class="button-icon" />
                           </button>
                        </div>
                     </div>
                  </td>
               </tr>
            </ng-template>
         </p-table>
      </div>
   </div>

   <!-- Edit UPN Modal -->
   <div
      *ngIf="isEditingMappingUPN"
      class="edit-custom-modal modal-dialog-centered">
      <div
         class="edit-modal-content"
         style="width: 480px">
         <div class="modal-heading">Edit Mapped User Principal Name</div>
         <div class="modal-upn">{{ currentUPN }}</div>

         <p style="margin-bottom: 4px">The UPN above maps to an existing Entra account.</p>
         <p>Use the input below to update this mapping.</p>

         <!-- Input for updatedUPN -->
         <input
            type="text"
            pInputText
            [(ngModel)]="updatedUPN"
            placeholder="Updated UPN"
            class="p-inputtext p-component"
            style="width: 80%; margin-top: 0px; padding: 8px; border: 1px solid #ccc; border-radius: 4px" />

         <!-- Validation Error Message -->
         <div style="width: 100%; display: flex; justify-content: center">
            <div style="width: 90%">
               <small
                  *ngIf="!isUPNValid && isSavingUPN"
                  class="p-error"
                  style="color: red; display: block; margin-top: 5px">
                  UPN can contain only letters, numbers, periods, dashes, underscores, and must end with &#64;vetcor.com.
               </small>
            </div>
         </div>

         <div style="width: 100%; display: flex; justify-content: center">
            <div style="margin-top: 12px; width: 60%">
               <p-button
                  label="Save Mapping"
                  variant="outlined"
                  severity="success"
                  fluid="true"
                  (click)="saveUpdatedUPN()" />
            </div>
         </div>

         <div style="width: 100%; display: flex; justify-content: center; margin-top: 24px; margin-bottom: 24px">
            <div style="width: 80%; border-top: 1px solid #ccc"></div>
         </div>

         <div style="width: 100%; display: flex; justify-content: center">
            <div style="width: 90%">
               <!-- <p>If the user also needs a new UPN or alias, please manage that on the Microsoft 365 Admin site</p> -->
               <p>If the UPN in the Entra account itself needs updating, please manage that using the Microsoft 365 Admin site</p>
            </div>
         </div>

         <div style="width: 100%; display: flex; justify-content: center">
            <div style="margin-top: 0px; width: 60%">
               <p-button
                  label="Open 365 Admin"
                  variant="outlined"
                  severity="info"
                  fluid="true"
                  (click)="openMicrosoft365Profile(currentUPN)" />
            </div>
         </div>

         <div style="width: 100%; display: flex; justify-content: center; margin-top: 24px; margin-bottom: 12px">
            <div style="width: 80%; border-top: 1px solid #ccc"></div>
         </div>

         <div style="width: 100%; display: flex; justify-content: center">
            <div style="margin-top: 12px; width: 60%">
               <p-button
                  label="Close Popup"
                  variant="outlined"
                  severity="danger"
                  fluid="true"
                  (click)="closePopup()" />
            </div>
         </div>
      </div>
   </div>
</div>
